<div class="surface-card p-4 shadow-2 border-round">
  <div class="mb-3 flex md:flex-row align-items-center md:justify-content-between justify-content-between ">
    <div class="flex justify-start md:justify-start">
      <span *ngIf="!filterIsSet" class="text-xl font-medium text-2000 align-items-center mr-4" style="color: rgb(10, 57, 29)">SEGNALAZIONI</span>
      <span *ngIf="filterIsSet && filtroStato" class="text-xl font-medium text-2000 align-items-center mr-4" style="color: rgb(48, 100, 197)">SEGNALAZIONI IN STATO:<span style="font-weight: bold;"> {{filtroStato}}</span> </span>
      <span *ngIf="filterIsSet && filtroSegnalazione" class="text-xl font-medium text-2000 align-items-center mr-4" style="color: rgb(106, 187, 25)">SEGNALAZIONE <span style="font-weight: bold;">{{filtroSegnalazione}}</span></span>

    </div>

  <div class="flex justify-end md:justify-end" style="align-items: center">

      <span style="margin-right: 1em">
        <p-button size="small" icon="pi pi-download" class="p-button-text mr-1" (click)="downloadAsExcel()"></p-button>
      </span>

      <p-multiSelect class="fieldFilterControl" *ngIf="!filterIsSet"
        [showHeader]="false"
        [filter]="false"
        [options]="opzioniAreeCompetenza"
        display="chip"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="filtroSegnalazioni.area"
        (onChange)="applyFilters()"
        placeholder="Area di competenza"
        [maxSelectedLabels]="1"
      />


      <p-multiSelect class="fieldFilterControl compact" *ngIf="!filterIsSet"
        [showHeader]="false"
        [filter]="false"
        [options]="opzioniTipoArea"
        [group]="true"
        display="chip"
        [(ngModel)]="filtroSegnalazioni.tipo"
        (onChange)="applyFilters()"
        placeholder="Tipo"
        [maxSelectedLabels]="1"
      />

      <p-multiSelect class="fieldFilterControl" *ngIf="!filterIsSet"
        [showHeader]="false"
        [filter]="false"
        [options]="opzioniStati"
        display="chip"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="filtroSegnalazioni.stato"
        (onChange)="applyFilters()"
        placeholder="Stato"
        [maxSelectedLabels]="1"
      />

      <p-multiSelect class="fieldFilterControl" *ngIf="!filterIsSet"
        [showHeader]="false"
        [filter]="false"
        [options]="opzioniPriority"
        display="chip"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="filtroSegnalazioni.priority"
        (onChange)="applyFilters()"
        placeholder="Priorità"
        [maxSelectedLabels]="1"
      />

      <p-multiSelect class="fieldFilterControl" *ngIf="!filterIsSet"
        display="chip"
        [options]="opzioniComuni"
        [showToggleAll]="false"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="filtroSegnalazioni.comune"
        (onChange)="applyFilters()"
        placeholder="Comune"
        [maxSelectedLabels]="1"
      />

    <span class="p-input-icon-left mr-4" *ngIf="!filterIsSet ">
      <i class="pi pi-search"></i>
      <input type="text" pInputText placeholder="Cerca" style="border-radius: 20px; width: 8em" [(ngModel)]="filtroSegnalazioni._all"
        (input)="filtraSegnalazioni($event)" [disabled]="isLoadingResults" *ngIf="!filterIsSet "/>
      </span>

    <div style="display: inline-block" class="buttonblock">

      <p-button styleClass="buttonblocked" icon="pi pi-filter-slash" size="small" class="p-button-text" pTooltip="rimuovi filtro" (click)="reloadDataRemovingFilter()" [disabled]="isLoadingResults"></p-button>
      <p-button *ngIf="!filterIsSet" styleClass="buttonblocked" size="small" icon="pi pi-upload" class="p-button-text" pTooltip="salva filtro" (click)="saveUiConfig()"></p-button>
      <p-button *ngIf="!filterIsSet" styleClass="buttonblocked" size="small" icon="pi pi-download" class="p-button-text" pTooltip="carica filtro salvato" (click)="applyUiConfig()"></p-button>

      </div>
<!--          <button [disabled]="(!filterIsSet) || isLoadingResults" pButton pRipple type="button" icon="pi pi-filter-slash"
           class="p-button mr-1" style="background-color: rgb(73, 162, 173); color: white;"
          (click)="reloadDataRemovingFilter()"
          pTooltip="Rimuovi filtro"></button>-->



      <button *ngIf="isAdmin || isOperatore "
      pButton type="button" icon="pi pi-plus"
              size="small"
      pTooltip="Nuova segnalazione"
      class="inline-flex justify-content-center align-items-center"
      style="background-color:#CBEFFF ; color: #007bff; border-color: #CBEFFF; font-family:'Poppins'; margin-left: 1em"
      tooltipPosition="top" (click)="openCreaSegnalazioneDialog()">
      </button>
     <!--  <button *ngIf="isAdmin || isSuperAdmin || isSuperVisore || isTecnico" pButton type="button" icon="pi pi-map" class="p-button-rounded p-button-outlined mr-2 ml-2" style="background-color: rgb(9, 175, 197); color: white;"  tooltipPosition="top" pTooltip="Nuova richiesta da Mappa"
      (click)="openCreaSegnalazioneDaMappaDialog()" [disabled]="isLoadingResults">
    </button> -->
    </div>
  </div>

  <p-tabView>
    <p-tabPanel>
      <ng-template pTemplate="header">
          <div class="flex align-items-center gap-2">
              <span class="font-bold white-space-nowrap m-0" style="color: #5EB1FC;">
                Elenco
              </span>
          </div>
      </ng-template>
        <div fxFlex="95%">

              <p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000" [breakpoints]="{'960px': '75vw', '640px': '100vw'}"> </p-confirmDialog>
             <!-- [globalFilterFields]="['id','idRichiesta','creata']"
                 -->
              <p-table #segnalazioniDT styleClass="p-datatable-sm" [value]="segnalazioniFiltrate" dataKey="id" [(selection)]="selectedSegnalazione"
                [selectionPageOnly]="true" [rowHover]="true" [rows]="30" [showCurrentPageReport]="true"
                [rowsPerPageOptions]="[30,50,100]" [loading]="isLoadingResults" responsiveLayout="stack" [paginator]="true"
                [globalFilterFields]="['id','codice','comune','segnalatore','descrizione']"
                [sortField]="'creata'" [sortOrder]="-1"
                [showCurrentPageReport]="true" currentPageReportTemplate="{first}-{last} di {totalRecords} segnalazioni"
                >
                <ng-template pTemplate="header">
                  <tr class="datatable-header">
                    <th>CODICE</th>
                    <!-- <th >REGIONE</th> -->
                    <th>PROVINCIA</th>
                    <th pSortableColumn="comune">
                      COMUNE
                      <p-sortIcon field="comune"></p-sortIcon>
                    </th>
                    <th pSortableColumn="nomeAutore">
                      AUTORE
                      <p-sortIcon field="nomeAutore"></p-sortIcon>
                    </th>
                    <th *ngIf="isAdmin || isOperatore">OPERATORE</th>
                    <th pSortableColumn="creata">
                      INSERITA
                      <p-sortIcon field="creata"></p-sortIcon>
                    </th>
                    <th pSortableColumn="modificata">
                      MODIFICATA
                      <p-sortIcon field="modificata"></p-sortIcon>
                    </th>
                    <th>DESCRIZIONE</th>
                    <th pSortableColumn="scadenza" class="text-center">
                      SCADENZA
                      <p-sortIcon field="scadenza"></p-sortIcon>
                    </th>
                    <th pSortableColumn="prioritaNumber" class="text-center">
                      PRIORITÀ
                      <p-sortIcon field="prioritaNumber"></p-sortIcon>
                    </th>
                    <th pSortableColumn="areaDiCompetenza" class="text-center">
                      AREA
                      <p-sortIcon field="areaDiCompetenza"></p-sortIcon>
                    </th>
                    <th pSortableColumn="tipo" class="text-center">
                      TIPO
                      <p-sortIcon field="tipo"></p-sortIcon>
                    </th>
                    <th>
                      STATO
                    </th>
                    <!-- <th class="text-center" style="width: 8px;"></th> -->
                    <th style="width: 8px;"></th>
                    <th style="width: 8px;"></th>
                    <th style="width: 8px;"></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row>
                  <tr>


                    <td> <span class="text-uppercase" style="font-size: 11px;font-weight: 500; font-weight: bold;"  >{{ row.label ? row.label : row.codice | uppercase}}</span></td>
                    <!-- <td> <span class="text-uppercase" >{{row.regione | uppercase}}</span></td> -->
                    <td> <span class="text-uppercase" style="font-size: 11px;">{{row.provincia | uppercase}}</span></td>
                    <td> <span class="text-uppercase" style="font-size: 11px;">{{row.comune | uppercase}}</span></td>
                    <td> <span class="text-uppercase" style="font-size: 11px;">{{row.nomeAutore | uppercase}}</span></td>
                    <td *ngIf="isAdmin || isOperatore "> <span class="text-uppercase" style="font-size: 11px;">{{row.nomeOperatoreInCarico | uppercase}}</span></td>
                    <td class="text-left"> <span class="text-lowercase" style="font-size: 11px;">{{formattaData(row.creata)}}</span></td>
                    <td class="text-left"> <span class="text-lowercase" style="font-size: 12px;">{{formattaData(row.modificata)}}</span></td>
                    <td class="text-left"> <span  style="font-size: 10px; font-weight: bold;">{{row.descrizione | uppercase}}</span></td>
                    <td class="text-left"> <span class="text-lowercase" style="font-size: 12px;">
                      {{formattaData(row["scadenza"])}}
                    </span></td>
                    <td class="text-center">
                      <span *ngIf="row.priorita" [ngClass]="stiliPrioritaSegnalazioni[row.priorita]" >{{ row.priorita | uppercase}}</span>
                    </td>
                    <td class="text-center">
                      <span
                      class="material-symbols-outlined small-icon"
                      [ngClass]="getAreaCompetenzaColor(row.areaDiCompetenza)"
                      [ngStyle]="{ 'color': getAreaCompetenzaColor(row.areaDiCompetenza) }"
                      [pTooltip]="row.areaDiCompetenza" tooltipPosition="top">
                      {{ stiliService.getMaterialIconAreaCompetenza(row.areaDiCompetenza) }}
                    </span>
                      <!-- <span  [ngClass]="stiliAreaCompetenzaSegnalazioni[row.areaDiCompetenza]"  style="font-size:9px;">{{row.areaDiCompetenza | uppercase}}</span> -->

                    </td>
                    <td class="text-center">
                      <span  class="tipo-segnalazione" [style]="{ 'background-color': getTipoSegnalazioneColor(row.tipo) }" style="font-size: 10px;">
                        {{row.tipo | uppercase}}
                      </span>
                      </td>
                    <td class="text-center">
                      <span
                        class="material-symbols-outlined small-icon"
                        [ngClass]="stiliService.getMaterialIconStatoSegnalazione(row.stato)"
                        [ngStyle]="{ 'color': stiliService.getColoreIconaStatoSegnalazione(row.stato) }"
                        [pTooltip]="getTooltipContent(row)" tooltipPosition="top">
                        {{ stiliService.getMaterialIconStatoSegnalazione(row.stato) }}
                      </span>
                      <!-- <span [ngClass]="stiliStatoSegnalazioni[row.stato]" style="font-size: 10px;">{{row.stato | uppercase}}</span> -->
                      </td>
                     <!--  <td class="text-center">
                        <i *ngIf="row.stato==='PIANIFICATA'" class="pi pi-calendar-clock" style="color: #07582a; cursor: pointer" pTooltip="Vedi pianificazioni"
                          tooltipPosition="top" (click)="apriInterventi(row)">
                        </i>
                      </td> -->
                      <td class="text-center">
                        <i *ngIf="row.allegato"  class="material-symbols-outlined small-icon" style="color: #033d63; cursor: pointer"
                        pTooltip="Mostra Allegati"
                          tooltipPosition="top" (click)="mostraAllegatiSegnalazione(row)">
                          attach_file
                        </i>
                      </td>
                      <td class="text-center">
                        <i *ngIf="isRisolta(row)"  class="material-symbols-outlined small-icon" style="color: #033d63; cursor: pointer"
                        pTooltip="Mostra note"
                          tooltipPosition="top" (click)="mostraNoteSegnalazione(row)">
                          edit_note
                        </i>
                        <i *ngIf="isRifiutata(row)"  class="material-symbols-outlined small-icon" style="color: #611f22; cursor: pointer"
                        pTooltip="Mostra note"
                          tooltipPosition="top" (click)="mostraNoteRifiuto(row)">
                          edit_note
                        </i>
                      </td>
                      <td>
                        <button *ngIf=" showPulsanteAzioni(row)"
                          pButton type="button" style="color:rgb(39, 128, 15)"
                          icon="pi pi-ellipsis-v" class="p-button-rounded p-button-text"
                          (click)="openCaricaAzioni($event,row)">
                        </button>
                      </td>
                  </tr>
                </ng-template>
              </p-table>
              <p-tieredMenu #menuAzioniTiered [popup]="true" [model]="menuAzioniItems"></p-tieredMenu>
            </div>

    </p-tabPanel>
    <p-tabPanel >
      <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2">
            <span class="font-bold white-space-nowrap m-0" style="color: #5EB1FC;">
              Mappa
            </span>
        </div>
    </ng-template>

        <div fxFlex="95%" style="height: 68vh">
          <app-activities-map-widget [interventi]="[]" [segnalazioni]="segnalazioniFiltrate" (onSelectSegnalazione)="openSingolaSegnalazione($event)"></app-activities-map-widget>
        </div>

    </p-tabPanel>
  </p-tabView>

</div>

<p-toast position="top-center"></p-toast>

<p-dialog [(visible)]="noteRisoluzioneVisibili" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '40vw'}" [closable]="false" [showHeader]="false">
  <div class="flex flex-column align-items-center my-4">
      <span class="flex align-items-center justify-content-center bg-cyan-100 text-cyan-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
          <i class="pi pi-clipboard text-5xl"></i>
      </span>
      <div class="font-medium text-2xl text-900">NOTE RISOLUZIONE</div>
  </div>
  <p class="line-height-3 p-0 m-0">
     {{noteRisoluzione}}
  </p>
  <ng-template pTemplate="footer">
    <div class="border-top-1 surface-border pt-3 flex-container">
      <button pButton pRipple icon="pi pi-times" (click)="noteRisoluzioneVisibili = false" label="CHIUDI" class="p-button-outlined w-6"></button>
  </div>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="noteRifiutoVisibili" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '40vw'}" [closable]="false" [showHeader]="false">
  <div class="flex flex-column align-items-center my-4">
      <span class="flex align-items-center justify-content-center bg-red-100 text-cyan-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
          <i class="pi pi-clipboard text-5xl"></i>
      </span>
      <div class="font-medium text-2xl text-900">NOTE RIFIUTO</div>
  </div>
  <p class="line-height-3 p-0 m-0">
     {{noteRifiuto}}
  </p>
  <ng-template pTemplate="footer">
    <div class="border-top-1 surface-border pt-3 flex-container">
      <button pButton pRipple icon="pi pi-times" (click)="noteRifiutoVisibili = false" label="CHIUDI" class="p-button-outlined w-6"></button>
  </div>
  </ng-template>
</p-dialog>
